import { render } from "./process.vue?vue&type=template&id=452d4bc6&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=452d4bc6&lang=scss&scoped=true"
import "./process.vue?vue&type=style&index=1&id=452d4bc6&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452d4bc6"]])

export default __exports__